import { Link } from 'react-router-dom';
import { Minus, Plus, Trash2 } from 'lucide-react';

import { useCart } from '@/store/cart.store';
import { formatRub } from '@/utils/format';
import { asAbsoluteUrl } from '@/utils/url';

export default function Cart() {
  const { items, inc, dec, remove, total } = useCart();

  if (items.length === 0) {
    return (
      <div className="px-4 pt-10 text-center">
        <div className="text-6xl mb-4">🛍</div>
        <h1 className="text-xl font-semibold mb-2">Корзина пуста</h1>
        <p className="text-sm text-slate-500 mb-6">Добавьте блюда из меню, чтобы оформить заказ.</p>
        <Link to="/menu" className="btn-primary">К меню</Link>
      </div>
    );
  }

  const t = total();

  return (
    <div className="pt-4 pb-24">
      <div className="px-4 mb-4">
        <h1 className="text-2xl font-semibold">Корзина</h1>
        <p className="text-sm text-slate-500">Проверьте состав и оформите заказ</p>
      </div>
      <div className="px-4 space-y-2">
        {items.map((i) => {
          const ext = i.modifiers.reduce((a, m) => a + m.price, 0);
          return (
            <div key={i.id} className="card p-3 flex gap-3">
              {i.photoUrl ? (
                <img
                  src={asAbsoluteUrl(i.photoUrl) ?? ''}
                  alt={i.name}
                  loading="lazy"
                  decoding="async"
                  className="w-20 h-20 rounded-xl object-cover bg-slate-100"
                  onError={(e) => { (e.currentTarget as HTMLImageElement).style.visibility = 'hidden'; }}
                />
              ) : (
                <div className="w-20 h-20 rounded-xl bg-slate-100 flex items-center justify-center text-2xl">🍽</div>
              )}
              <div className="flex-1 min-w-0">
                <div className="font-medium">{i.name}</div>
                {i.modifiers.length > 0 && (
                  <div className="text-xs text-slate-500 mt-0.5">
                    {i.modifiers.map((m) => m.name).join(', ')}
                  </div>
                )}
                <div className="font-semibold mt-1">{formatRub((i.price + ext))}</div>
                <div className="flex items-center gap-2 mt-2">
                  <button className="p-1.5 rounded-lg bg-slate-100" onClick={() => dec(i.id)}>
                    <Minus size={14} />
                  </button>
                  <span className="min-w-[20px] text-center text-sm">{i.quantity}</span>
                  <button className="p-1.5 rounded-lg bg-slate-100" onClick={() => inc(i.id)}>
                    <Plus size={14} />
                  </button>
                  <button className="ml-auto p-1.5 rounded-lg text-red-500" onClick={() => remove(i.id)}>
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="fixed bottom-16 left-0 right-0 bg-white border-t border-slate-100 safe-bottom">
        <div className="max-w-lg mx-auto px-4 py-3 flex items-center gap-3">
          <div>
            <div className="text-xs text-slate-500">Итого</div>
            <div className="text-lg font-semibold">{formatRub(t)}</div>
          </div>
          <Link to="/checkout" className="btn-primary flex-1">Оформить заказ</Link>
        </div>
      </div>
    </div>
  );
}
